import { Outlet } from "react-router-dom";

export default function CheckoutLayout() {
    return (
        <>
        <Outlet />
        </>
    )
}